module.exports = __webpack_public_path__ + "img/brand_icon05.36c83f4.602f70e1.png";